<template v-if="moduls.modulos[moduloIndex].activo || selectedOption === 'editar'">
    <v-col v-if="leccionActual.video" cols="12">
        <iframe width="100%" style="aspect-ratio: 16 / 9; height: auto; max-height: calc(100dvh - 160px);"
            :src="leccionActual.video.url" title="Video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>
    </v-col>
    <v-col v-if="leccionActual.imagenes_arriba && leccionActual.imagenes_arriba.length > 0" cols="12"
        :key="leccionActual.id"> <!-- Forces remount when lesson changes -->
        <v-carousel height="auto" :hide-delimiters="leccionActual.imagenes_arriba.length === 1"
            hide-delimiter-background :show-arrows="leccionActual.imagenes_arriba.length > 1 ? 'hover' : false">
            <v-carousel-item v-for="imagen in leccionActual.imagenes_arriba" :key="imagen.id">
                <div class="d-flex justify-center" v-if="['.mp4', '.webm', '.ogg'].includes(imagen.file_type)">
                    <video controls autoplay loop class="w-100"
                        style="height: auto; max-height: calc(100dvh - 160px); object-fit: contain;">
                        <source :src="imagen.imagen" :type="`video/${imagen.file_type.replace('.', '')}`" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div v-else-if="imagen.file_type === '.mp3'" class="d-flex justify-center align-center h-100">
                    <audio controls class="w-100">
                        <source :src="imagen.imagen" type="audio/mpeg" />
                        El navegador no admet àudio.
                    </audio>
                </div>
                <v-img v-else class="bg-grey-lighten-2" :src="imagen.imagen" />
            </v-carousel-item>
        </v-carousel>
    </v-col>
    <v-col cols="12">
        <v-card class="mx-0 mx-sm-4">
            <v-card-subtitle style="word-break: break-word;" class="mt-4 text-wrap">{{ curso.titulo }} - {{
                moduls.modulos[moduloIndex].titulo
                }}</v-card-subtitle>
            <v-card-actions v-if="selectedOption === 'editar'">
                <v-btn color="primary" @click="openModuleDialog()" prepend-icon="mdi-pencil">
                    {{ t('Editar') }}
                </v-btn>
                <v-btn color="secondary" prepend-icon="mdi-sort" @click="showSortDialog = true">
                    {{ t('Ordenar') }}
                </v-btn>
                <v-btn color="error" @click="confirmDelete(leccionActual.id)" prepend-icon="mdi-delete">
                    {{ t('Eliminar') }}
                </v-btn>
            </v-card-actions>
            <v-card-title class="text-h4 text-wrap font-weight-bold my-2" style="word-break: break-word">{{
                leccionActual.titulo }}</v-card-title>
            <!-- Icono de descarga de PDF -->
            <v-btn class="ma-4" v-if="leccionActual.archivo_pdf" @click="descargarPDF(leccionActual.archivo_pdf)">
                <v-icon>mdi-file-download-outline</v-icon> {{ t('Descargar') }} PDF
            </v-btn>
            <v-card-text>
                <v-alert v-if="!moduls.modulos[moduloIndex].activo">Este módulo todavía no está activo.</v-alert>
                <v-row align="center" justify="center">
                    <v-col cols="12" class="d-flex align-center justify-center">
                        <MarkdownText :markdownText="leccionActual.descripcion"></MarkdownText>
                    </v-col>
                    <template v-if="leccionActual.pdfs && leccionActual.pdfs.length > 0">
                        <v-col cols="12" class="d-flex flex-wrap align-center justify-center">
                            <v-chip v-for="pdf in leccionActual.pdfs" :key="pdf.id" :text="pdf.descripcion"
                                :href="pdf.pdf" target="_blank" :prepend-icon="getFileIcon(pdf.file_type)" class="ma-2">
                            </v-chip>
                        </v-col>
                    </template>
                    <template v-if="leccionActual.imagenes_lateral && leccionActual.imagenes_lateral.length > 0">
                        <v-col cols="12" class="d-flex flex-wrap align-center justify-center"
                            style="min-width: 0; max-width: 100%;">
                            <v-card v-for="imagen in leccionActual.imagenes_lateral" :key="imagen.id" :style="{
                                width: `min(${Number(imagen.mida) || 200}px, 100%, calc(100vw - 32px))`,
                                minWidth: '0'
                            }">
                                <div v-if="['.mp4', '.webm', '.ogg'].includes(imagen.file_type)">
                                    <video controls autoplay muted loop style="width: 100%;">
                                        <source :src="imagen.imagen"
                                            :type="`video/${imagen.file_type.replace('.', '')}`" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div v-else-if="imagen.file_type === '.mp3'"
                                    class="d-flex justify-center align-center h-100">
                                    <audio controls class="w-100">
                                        <source :src="imagen.imagen" type="audio/mpeg" />
                                        El navegador no admet àudio.
                                    </audio>
                                </div>
                                <v-img v-else class="bg-grey-lighten-2" :src="imagen.imagen" width="100%" />
                                <v-card-subtitle class="text-wrap" style="word-break: break-word">
                                    {{ imagen.descripcion }}
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
    </v-col>

    <v-dialog v-model="showDialog" persistent>
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Eliminando') + ' ' + t('leccion')" />
            <template v-if="!loading">
                <v-card-title>{{ t('Estás_seguro') }}</v-card-title>
                <v-card-text>
                    {{ t('Estás_seguro_que_quieres_eliminar') }} la lección "{{
                        leccionToDelete?.titulo
                    }}"?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" text @click="showDialog = false">{{ t('Cancelar') }}</v-btn>
                    <v-btn color="error" text @click="eliminarLeccion">{{ t('Eliminar') }}</v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>

    <!-- Diálogo para editar leccion -->
    <v-dialog v-model="showModuleDialog" persistent>
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Actualizando') + ' ' + t('leccion')" />
            <template v-if="!loading">
                <v-toolbar flat>
                    <v-toolbar-title>{{ t('Editar') }} {{ t('lecciones') }}</v-toolbar-title>
                    <v-btn @click="actualizarLeccion" prepend-icon="mdi-content-save">
                        {{ t('Guardar') }}
                    </v-btn>
                    <v-btn icon @click="showModuleDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel :title="t('Multimedia')">
                            <v-expansion-panel-text>
                                <!-- Botón para modificar video -->
                                <v-btn block @click="showVideoDialog = true">
                                    {{ leccionActual.video ? t('Editar') : t('Anadir') }} {{
                                        t('Video_externo_youtube_o_vimeo') }}
                                </v-btn>
                                <v-card class="my-4">
                                    <v-card-title>{{ t('Imagenes') }} {{ t('o') }} {{ t('videos') }}</v-card-title>
                                    <v-card-text v-if="leccionActual.imagenes">
                                        <v-list v-for="imagen in leccionActual.imagenes" :key="imagen.id">
                                            <v-list-item @click="editImagen(imagen)">
                                                <v-list-item-title class="text-wrap" style="word-break: break-word">{{
                                                    imagen.descripcion }}
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn @click="newImagen" prepend-icon="mdi-plus">
                                            {{ t('Anadir') }} {{ t('imagen') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                                <v-card>
                                    <v-card-title>{{ t('Documentos') }}</v-card-title>

                                    <template v-if="leccionActual.pdfs"> <v-list v-for="pdf in leccionActual.pdfs"
                                            :key="pdf.id">
                                            <v-list-item @click="editPDF(pdf)">
                                                <v-list-item-title class="text-wrap" style="word-break: break-word">{{
                                                    pdf.descripcion }}
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </template>
                                    <v-card-actions>
                                        <v-btn @click="newPDF">
                                            {{ t('Anadir') }} PDF
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel :title="t('Texto')">
                            <v-expansion-panel-text><v-text-field v-model="leccionForm.titulo" :label="t('Título')"
                                    :rules="[v => !!v || 'Campo requerido']"></v-text-field>
                                <v-textarea v-model="leccionForm.descripcion" :label="t('Descripción')"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    auto-grow></v-textarea></v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
            </template>
        </v-card>
    </v-dialog>

    <!-- Diálogo para video -->
    <v-dialog v-model="showVideoDialog" persistent>
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Actualizando') + ' ' + t('video')" />
            <template v-if="!loading">
                <v-toolbar color="info" dark flat>
                    <v-toolbar-title>{{ videoDialogTitle }}</v-toolbar-title>
                    <v-btn color="primary" @click="saveVideo" prepend-icon="mdi-content-save">{{ t('Guardar') }}</v-btn>
                    <v-btn v-if="leccionForm.video.id" color="error" text @click="eliminarVideo"
                        prepend-icon="mdi-delete">{{ t('Eliminar') }}</v-btn>
                    <v-btn icon @click="showVideoDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field v-model="leccionForm.video.url" label="URL del Video"><template v-slot:append>
                            <HelpComponent helpType="video_url"></HelpComponent>
                        </template></v-text-field>
                    <v-text-field v-model="leccionForm.video.titulo" label="Título del Video"></v-text-field>
                </v-card-text></template>
        </v-card>
    </v-dialog>

    <!-- Diálogo para imagen -->
    <v-dialog v-model="showImagenDialog" persistent>
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Actualizando') + ' ' + t('imagen')" />
            <template v-if="!loading">
                <v-toolbar color="info" dark flat>
                    <v-toolbar-title>{{ imagenDialogTitle }}</v-toolbar-title>
                    <v-btn color="primary" @click="saveImagen" prepend-icon="mdi-content-save">{{ t('Guardar')
                        }}</v-btn>
                    <v-btn v-if="editedImagen.id" color="error" text @click="eliminarImagen"
                        prepend-icon="mdi-delete">{{
                            t('Eliminar') }}</v-btn>
                    <v-btn icon @click="showImagenDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-file-input v-model="editedImagen.imagen" :label="t('Imagen') + ' ' + t('o') + ' ' + t('video')"
                        prepend-icon="mdi-camera" accept="image/*,video/*" @change="handleFileUpload2"><template
                            v-slot:append>
                            <HelpComponent helpType="imagen_leccion"></HelpComponent>
                        </template></v-file-input>
                    <v-text-field v-model="editedImagen.descripcion" :label="t('Leyenda_de_la_imagen')"><template
                            v-slot:append>
                            <HelpComponent helpType="imagen_descripcion"></HelpComponent>
                        </template></v-text-field>
                    <v-select v-model="editedImagen.tipo" :items="['lateral', 'arriba']"
                        :label="t('Posicion')"><template v-slot:append>
                            <HelpComponent helpType="imagen_posicion"></HelpComponent>
                        </template>
                    </v-select>
                    <v-text-field v-if="editedImagen.tipo === 'lateral'" v-model.number="editedImagen.mida"
                        :label="t('Ancho_preferido_px')" type="number" min="1" step="1" />
                    <!-- Verifica si hay una URL de imagen y muestra el thumbnail -->
                    <template v-if="editedImagen.imagen_thub">
                        <!-- If it's an image -->
                        <v-img v-if="editedImagen.imagen_type && editedImagen.imagen_type.startsWith('image/')"
                            :src="editedImagen.imagen_thub" height="100" />
                        <!-- If it's a video -->
                        <video v-else-if="editedImagen.imagen_type && editedImagen.imagen_type.startsWith('video/')"
                            controls style="max-width: 300px;">
                            <source :src="editedImagen.imagen_thub" :type="editedImagen.imagen_type" />
                            <!-- Provide fallback text if needed -->
                            {{ t('Tu navegador no soporta el video') }}
                        </video>
                    </template>
                </v-card-text>
            </template>
        </v-card>
    </v-dialog>

    <!-- Diálogo para PDF -->
    <v-dialog v-model="showPDFDialog" persistent>
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Actualizando') + ' ' + 'PDF'" />
            <template v-if="!loading">
                <v-toolbar color="info" dark flat>
                    <v-toolbar-title>{{ PDFDialogTitle }}</v-toolbar-title>
                    <v-btn color="primary" @click="savePDF" prepend-icon="mdi-content-save">{{ t('Guardar') }}</v-btn>
                    <v-btn v-if="editedPDF.id" color="error" text @click="eliminarPDF" prepend-icon="mdi-delete">{{
                        t('Eliminar') }}</v-btn>
                    <v-btn icon @click="showPDFDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field v-model="editedPDF.descripcion" label="Leyenda del PDF"></v-text-field>
                    <v-file-input v-model="editedPDF.pdf" label="PDF" prepend-icon="mdi-file"
                        @change="handleFileUpload3">
                    </v-file-input>
                </v-card-text></template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showSortDialog" persistent max-width="600px">
        <v-card>
            <HelperCarregant v-if="loading" :missatge="t('Reordenando') + ' ' + t('lecciones')" />
            <template v-if="!loading">
                <v-toolbar flat>
                    <v-toolbar-title>{{ t('Reordenar') }} {{ t('lecciones') }}</v-toolbar-title>
                    <v-btn @click="actualizarOrden" prepend-icon="mdi-content-save">
                        {{ t('Guardar') }}
                    </v-btn>
                    <v-btn icon @click="showSortDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-list dense>
                        <v-list-item v-for="(leccion, index) in moduls.modulos[moduloIndex].lecciones"
                            :key="leccion.id">
                            <v-list-item-title>
                                {{ leccion.titulo }}
                            </v-list-item-title>
                            <template v-slot:append>
                                <v-btn icon="mdi-arrow-up" @click="moveModuleUp(index)"></v-btn>
                                <v-btn icon="mdi-arrow-down" @click="moveModuleDown(index)"></v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </template>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, computed } from 'vue'
import { useUiStore } from '@/stores/ui';
import { useI18n } from 'vue-i18n'
import HelperCarregant from './HelperCarregant.vue'
import HelpComponent from './HelpComponent.vue'
import MarkdownText from './MarkdownText.vue'
import { axios } from '../axios'

// -----------------
// Define Props/Emits
// -----------------
const props = defineProps({
    curso: {
        type: Object,
        default: () => ({})
    },
    moduls: {
        type: Object,
        default: () => ({})
    },
    leccionActual: {
        type: Object,
        default: () => ({})
    },
    moduloIndex: Number,
    leccionIndex: Number,
    selectedOption: String
})

const emit = defineEmits([
    'reorder-lecciones',
    'update-leccion',
    'delete-leccion'
])

// -----------------
// Setup
// -----------------
const uiStore = useUiStore();
const { t } = useI18n()

// -----------------
// Reactive State
// -----------------

const editedImagen = ref({})
const editedPDF = ref({})
const showModuleDialog = ref(false)
const showVideoDialog = ref(false)
const showImagenDialog = ref(false)
const showPDFDialog = ref(false)
const showDialog = ref(false)
const showSortDialog = ref(false)
const pdfExisteix = ref(false)
const panel = ref([1]);
const snackbarText = ref('')
const loading = ref(false)
const pendingDeleteId = ref(null)
const leccionForm = ref({
    id: '',
    titulo: '',
    descripcion: '',
    archivo_pdf: null,
    orden: null,
    video: {
        id: '',
        leccion: '',
        url: '',
        titulo: ''
    }
})

// Get the actual lesson object we plan to delete
const leccionToDelete = computed(() => {
    if (!pendingDeleteId.value) return null
    return props.moduls.modulos[props.moduloIndex].lecciones.find(
        (lec) => lec.id === pendingDeleteId.value
    )
})

// -----------------
// Computed
// -----------------
const videoDialogTitle = computed(() =>
    leccionForm.value.video.url
        ? `${t('Editar')} ${t('video')}`
        : `${t('Añadir')} ${t('video')}`
)
const imagenDialogTitle = computed(() =>
    editedImagen.value.id
        ? `${t('Editar')} ${t('imagen')}`
        : `${t('Añadir')} ${t('imagen')}`
)

const PDFDialogTitle = computed(() =>
    editedPDF.value.id
        ? `${t('Editar')} ${t('PDF')}`
        : `${t('Añadir')} ${t('PDF')}`
)

// -----------------
// Methods
// -----------------

function getFileIcon(fileType) {
    const type = fileType.toLowerCase();
    if (type === '.pdf') {
        return 'mdi-file-pdf-box';
    } else if (type === '.doc' || type === '.docx') {
        return 'mdi-file-word-box';
    } else if (type === '.xls' || type === '.xlsx') {
        return 'mdi-file-excel-box';
    } else if (type === '.ppt' || type === '.pptx') {
        return 'mdi-file-powerpoint-box';
    } else {
        return 'mdi-file-document';
    }
}

function editImagen(imagen) {
    // Clone item to avoid mutating original
    editedImagen.value = {
        ...imagen,
        leccion: props.leccionActual.id,
        imagen: null,
        imagen_thub: imagen.imagen,
        imagen_type: imagen.imagen ? guessMimeType(imagen.imagen) : null,
        mida: imagen.mida ?? 200,
    }
    showImagenDialog.value = true
}

function editPDF(pdf) {
    // Clone item to avoid mutating original
    editedPDF.value = {
        ...pdf,
        pdf: null,
        leccion: props.leccionActual.id,
    }
    showPDFDialog.value = true
}

function newImagen() {
    editedImagen.value = {
        id: null,
        leccion: props.leccionActual.id,
        descripcion: '',
        imagen: null,
        imagen_type: null,
        imagen_thub: null,
        tipo: 'lateral',
        mida: 200,
    }
    showImagenDialog.value = true
}

function newPDF() {
    editedPDF.value = {
        id: null,
        leccion: props.leccionActual.id,
        descripcion: '',
        pdf: null,
    }
    showPDFDialog.value = true
}

function handleFileUpload2(event) {
    const files = event.target.files
    if (files && files.length > 0) {
        // Use the first file
        const file = files[0]
        editedImagen.value.imagen = file        // actual File object
        editedImagen.value.imagen_type = file.type // "image/png", "video/mp4", etc.

        // Use FileReader to create a base64 string for preview (thumbnail)
        const reader = new FileReader()
        reader.onload = (e) => {
            editedImagen.value.imagen_thub = e.target.result
        }
        reader.readAsDataURL(file)
    } else {
        // Reset if no file
        editedImagen.value.imagen = null
        editedImagen.value.imagen_type = null
        editedImagen.value.imagen_thub = null
    }
}

function handleFileUpload3(event) {
    if (event.target.files && event.target.files.length > 0) {
        editedPDF.value.pdf = event.target.files[0]
    } else {
        editedPDF.value.pdf = null
    }
}

function guessMimeType(url) {
    const extension = url
        .split('?')[0]          // ignore query params, if any
        .split('.')
        .pop()
        .toLowerCase()

    if (['mp4', 'mov', 'avi', 'mkv'].includes(extension)) {
        return 'video/mp4'
    }
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension)) {
        return `image/${extension}`
    }
    // fallback if unknown
    return null
}

function descargarPDF(url) {
    window.open(url, '_blank')
}

async function saveVideo() {
    loading.value = true
    try {
        if (leccionForm.value.video.id) {
            // Update video
            await axios.put(`videos/${leccionForm.value.video.id}/`, leccionForm.value.video)
            uiStore.triggerSnackbar({
                message: t('actualizado_con_éxito'),
                color: 'success'
            })
        } else {
            // Create video
            await axios.post('videos/', leccionForm.value.video)
            uiStore.triggerSnackbar({
                message: t('creado_con_éxito'),
                color: 'success'
            })
        }
        showVideoDialog.value = false
        emit('update-leccion')
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            const errors = error.response.data
            let errorMessage = ''
            Object.keys(errors).forEach((key) => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`
            })
            snackbarText.value = errorMessage
        } else {
            snackbarText.value = error
        }
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

async function saveImagenDirecta(file) {
    const contentType = file.type || 'application/octet-stream'

    // 1. Pedimos a Django una URL temporal de subida.
    // Django solo la dará si request.user.is_staff.
    const response = await axios.post(
        'imagenes/direct-upload-url/',
        {
            filename: file.name,
            content_type: contentType,
            size: file.size,
        }
    )

    const { upload_url, object_name } = response.data

    // 2. El archivo va directamente del navegador a Google Cloud Storage.
    // IMPORTANTE: aquí usamos fetch, no nuestro axios configurado.
    const uploadResponse = await fetch(upload_url, {
        method: 'PUT',
        headers: {
            'Content-Type': contentType,
        },
        body: file,
    })

    if (!uploadResponse.ok) {
        throw new Error(
            `Error al subir el archivo a Storage (${uploadResponse.status})`
        )
    }

    // 3. Decimos a Django que el archivo ya está en GCS
    // para que cree el objeto Imagen en la base de datos.
    await axios.post(
        'imagenes/direct-upload-complete/',
        {
            object_name: object_name,
            leccion: editedImagen.value.leccion,
            descripcion: editedImagen.value.descripcion || '',
            tipo: editedImagen.value.tipo || 'lateral',
            mida: editedImagen.value.mida || 200,
        }
    )
}

async function saveImagen() {
    loading.value = true

    try {
        const file = editedImagen.value.imagen

        // Dejamos margen respecto al límite de 32 MB de App Engine.
        const DIRECT_UPLOAD_THRESHOLD = 25 * 1024 * 1024

        // ---------------------------------------------------------
        // ARCHIVO GRANDE
        // ---------------------------------------------------------
        if (
            file instanceof File &&
            file.size > DIRECT_UPLOAD_THRESHOLD
        ) {
            // De momento la subida directa grande es para archivos nuevos.
            if (editedImagen.value.id) {
                throw new Error(
                    'La sustitución de un archivo existente por uno de gran tamaño todavía no está habilitada.'
                )
            }

            await saveImagenDirecta(file)

            uiStore.triggerSnackbar({
                message: t('creado_con_éxito'),
                color: 'success'
            })
        }

        // ---------------------------------------------------------
        // ARCHIVO NORMAL: comportamiento actual
        // ---------------------------------------------------------
        else {
            const formData = new FormData()

            for (const key in editedImagen.value) {
                const value = editedImagen.value[key]

                if (value !== null && value !== undefined) {
                    if (key === 'imagen') {
                        if (value instanceof File) {
                            formData.append(key, value)
                        }
                    } else {
                        formData.append(key, value)
                    }
                }
            }

            if (editedImagen.value.id) {
                if (!(editedImagen.value.imagen instanceof File)) {
                    await axios.patch(
                        `imagenes/${editedImagen.value.id}/`,
                        formData
                    )
                } else {
                    await axios.put(
                        `imagenes/${editedImagen.value.id}/`,
                        formData
                    )
                }

                uiStore.triggerSnackbar({
                    message: t('actualizado_con_éxito'),
                    color: 'success'
                })
            } else {
                await axios.post(
                    'imagenes/',
                    formData
                )

                uiStore.triggerSnackbar({
                    message: t('creado_con_éxito'),
                    color: 'success'
                })
            }
        }

        showImagenDialog.value = false
        emit('update-leccion')

    } catch (error) {
        let errorMessage = ''

        if (error.response?.data?.detail) {
            errorMessage = error.response.data.detail
        } else if (
            error.response?.data &&
            typeof error.response.data === 'object'
        ) {
            errorMessage = Object.entries(error.response.data)
                .map(([key, value]) => {
                    const text = Array.isArray(value)
                        ? value.join(' ')
                        : value

                    return `${key}: ${text}`
                })
                .join('\n')
        } else if (error.message) {
            errorMessage = error.message
        } else {
            errorMessage = String(error)
        }

        snackbarText.value = errorMessage

        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

async function savePDF() {
    loading.value = true
    const formData = new FormData()
    for (const key in editedPDF.value) {
        const value = editedPDF.value[key]
        if (value !== null && value !== undefined) {
            if (key === 'pdf' && value instanceof File) {
                formData.append(key, value)
            } else {
                formData.append(key, value)
            }
        }
    }
    try {
        if (editedPDF.value.id) {
            // If updating and no new file is selected, use PATCH for a partial update
            if (!(editedPDF.value.pdf instanceof File)) {
                await axios.patch(`pdfs/${editedPDF.value.id}/`, formData)
            } else {
                // If a new file is selected, you can use PUT (or PATCH)
                await axios.put(`pdfs/${editedPDF.value.id}/`, formData)
            }
            uiStore.triggerSnackbar({
                message: t('actualizado_con_éxito'),
                color: 'success'
            })
        } else {
            // Create
            await axios.post(`pdfs/`, formData)
            uiStore.triggerSnackbar({
                message: t('creado_con_éxito'),
                color: 'success'
            })
        }
        showPDFDialog.value = false
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
    } finally {
        loading.value = false
    }
}

async function actualizarLeccion() {
    loading.value = true
    const formData = new FormData()

    // Build FormData, carefully handling file inputs
    Object.keys(leccionForm.value).forEach((key) => {
        const value = leccionForm.value[key]
        if (value !== null && value !== undefined) {
            if (key === 'archivo_pdf' && value instanceof File) {
                formData.append(key, value)
            } else if (typeof value !== 'object' || value instanceof File) {
                formData.append(key, value)
            }
            // If needed, handle "video" or other nested objects separately
        }
    })

    try {
        const response = await axios.put(`lecciones/${leccionForm.value.id}/`, formData)
        showModuleDialog.value = false
        snackbarText.value = response.data.titulo + ' ' + t('fue_actualizado_con_éxito')
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            const errors = error.response.data
            let errorMessage = ''
            Object.keys(errors).forEach((key) => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`
            })
            snackbarText.value = errorMessage
        } else {
            snackbarText.value = error
        }
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

function confirmDelete(id) {
    pendingDeleteId.value = id
    showDialog.value = true
}


async function eliminarLeccion() {
    loading.value = true
    try {
        // Use the stored ID for deletion
        await axios.delete(`lecciones/${pendingDeleteId.value}/`)

        // Emit to the parent that we deleted a lesson with this ID
        emit('delete-leccion', pendingDeleteId.value)

        showDialog.value = false
        snackbarText.value = `${t('La_leccion')} ${t('se_ha_eliminado_con_éxito')}`
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

async function eliminarVideo() {
    loading.value = true
    const videoId = leccionForm.value.video.id
    try {
        await axios.delete(`videos/${videoId}/`)
        showVideoDialog.value = false
        snackbarText.value = t('se_ha_eliminado_con_éxito')
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

async function eliminarImagen() {
    loading.value = true
    const imagenId = editedImagen.value.id
    try {
        await axios.delete(`imagenes/${imagenId}/`)
        showImagenDialog.value = false
        snackbarText.value = t('se_ha_eliminado_con_éxito')
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

async function eliminarPDF() {
    loading.value = true
    const pdfId = editedPDF.value.id
    try {
        await axios.delete(`pdfs/${pdfId}/`)
        showPDFDialog.value = false
        snackbarText.value = t('se_ha_eliminado_con_éxito')
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
    }
}

function openModuleDialog() {
    // Copy existing module info into form
    leccionForm.value.titulo = props.leccionActual.titulo
    leccionForm.value.descripcion = props.leccionActual.descripcion
    leccionForm.value.id = props.leccionActual.id
    leccionForm.value.modulo = props.leccionActual.modulo
    leccionForm.value.orden = props.leccionActual.orden

    pdfExisteix.value = !!props.leccionActual.archivo_pdf
    leccionForm.value.archivo_pdf = null

    if (!props.leccionActual.video || !props.leccionActual.video.url) {
        leccionForm.value.video = {
            leccion: props.leccionActual.id,
            url: '',
            titulo: ''
        }
    } else {
        leccionForm.value.video = {
            leccion: props.leccionActual.id,
            id: props.leccionActual.video.id,
            url: props.leccionActual.video.url,
            titulo: props.leccionActual.video.titulo
        }
    }
    showModuleDialog.value = true
}

function moveModuleUp(index) {
    if (index > 0) {
        emit('reorder-lecciones', { type: 'up', index })
    }
}

function moveModuleDown(index) {
    if (index < props.moduls.modulos[props.moduloIndex].lecciones.length - 1) {
        emit('reorder-lecciones', { type: 'down', index })
    }
}

async function actualizarOrden() {
    loading.value = true
    const orderedModuleIds =
        props.moduls.modulos[props.moduloIndex].lecciones.map((leccion) => leccion.id)

    try {
        await axios.put('lecciones/reorder/', {
            curso_id: props.curso.id,
            modulo: props.moduls.modulos[props.moduloIndex].id,
            new_order: orderedModuleIds
        })
        snackbarText.value = t('Orden_guardado_con_éxito')
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'success'
        })
        emit('update-leccion')
    } catch (error) {
        snackbarText.value = error
        uiStore.triggerSnackbar({
            message: snackbarText.value,
            color: 'error'
        })
    } finally {
        loading.value = false
        showSortDialog.value = false
    }
}
</script>